<template>
  <div v-if="commentary">
    <b-form-group
      class="labelTextArea"
      label-for="npsTextarea"
    >
    <template slot="label">Gostaríamos de entender os motivos da sua resposta <span class="opcional">(Opcional)</span></template>
      <b-form-textarea
        id="npsTextarea"
        v-model="reasonOfScore"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'ReasonOfScore',
  props: {
    reasonOfScoreProps: String,
    companyName: String,
    commentary: Boolean
  },
  data () {
    return {
      description: ''
    }
  },
  created () {
    if (!this.companyName) {
      this.companyName = 'o Jaleko'
    }
  },
  computed: {
    reasonOfScore: {
      get: function () {
        return this.reasonOfScoreProps
      },
      set: function (newValue) {
        this.$emit('update-reasonOfScore', newValue)
      }
    }
  }
}
</script>
